const forgotPassword = {
  forgotYourPassword: 'Passwort vergessen?',
  backToLogin: 'Weiter zur Anmeldung',
  sendResetLink: 'Link zum Zurücksetzen senden',
  emailHint: 'Die E-Mail-Adresse, die Sie von Ihrem Administrator erhalten haben',
  noWorries: 'Kein Problem! Bitte geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.',
  PleaseEnterEmailAddress: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
  thankYou: 'Danke!',
  forgotPassword: 'Passwort vergessen',
  successHint: 'we will send a link to reset your password in a few seconds,Wenn die von Ihnen eingegebene E-Mail in unserem System vorhanden ist, senden wir Ihnen in wenigen Sekunden einen Link zum Zurücksetzen Ihres Passworts, we will send a link to reset your password in a few seconds',
  emailAddress: 'E-Mail-Adresse',
  redirect: 'You will be redirected in ',
  seconds: ' seconds',
  emailRequires: 'E-Mail ist erforderlich',
  invalidEmail: 'E-Mail ist ungültig',
};

export default forgotPassword;
